import React from "react";
import { HiOutlinePhoto } from "react-icons/hi2";

export function PosterImage({ imgUrl, alt }) {
  return (
    <div className="flex-shrink-0 mb-3 w-full">
      <div
        className="w-full rounded-lg overflow-hidden bg-black/20 flex items-center justify-center"
        style={{ aspectRatio: "4/3", minHeight: 100, maxHeight: 180 }}
      >
        {imgUrl ? (
          <img
            src={imgUrl}
            alt={alt}
            className="w-full h-full object-cover min-w-0 min-h-0"
          />
        ) : (
          <HiOutlinePhoto className="w-14 h-14 text-white/30" />
        )}
      </div>
    </div>
  );
}
